<template>
  <div class="item" @click="$emit('click', data.name, data.id)">
    <div class="item-head">
      <img
        draggable="false"
        :src="require('/public/static/img/status/site.png')"
        alt=""
      />
      <el-tooltip
        :disabled="data.site.length <= 13"
        effect="dark"
        :content="data.site"
        placement="top"
      >
        <span>{{ data.site }}</span>
      </el-tooltip>
    </div>
    <div class="item-body">
      <div class="item-body--title">{{ data.name }}</div>
      <div class="item-body--status">
        <div>
          <img
            draggable="false"
            :src="require('/public/static/img/status/humidity.png')"
            alt=""
          />
          <span
            >湿度: <span>{{ data.humidity }}</span></span
          >
        </div>
        <div>
          <img
            draggable="false"
            :src="require('/public/static/img/status/temp.png')"
            alt=""
          />
          <span
            >温度: <span>{{ data.temperature }}</span></span
          >
        </div>
        <div>
          <img
            draggable="false"
            :src="require('/public/static/img/status/door.png')"
            alt=""
          />
          <span
            >柜门: <span>{{ data.doorStatus }}</span></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    data: {
      type: Object,
      defalut: () => ({})
    }
  },
  setup() {
    return {};
  }
};
</script>
<style scoped lang="less">
.item {
  cursor: pointer;
  .item-head {
    margin: 0 16px;
    margin-bottom: 6px;
    font-size: 16px;
    color: #b2d1f9;
    display: flex;
    align-items: center;
    img {
      display: inline-block;
      vertical-align: sub;
      margin-right: 10px;
    }
    span {
      display: inline-block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .item-body {
    position: relative;
    user-select: none;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 4px;
    opacity: 0.7;
    height: 105px;
    margin-bottom: 20px;
    padding: 0 30px;
    .item-body--title {
      font-family: MicrosoftYaHei-Bold;
      font-size: 15px;
      font-weight: bold;
      text-align: left;
      color: #fff;
      padding-top: 10px;
    }
    .item-body--status {
      background-color: transparent !important;
      box-shadow: 0 0 6px rgb(58, 227, 194, 89%);
      margin-top: 10px;
      border-radius: 2px;
      padding-left: 10px;
      > div {
        display: inline-block;
        font-size: 15px;
        width: 50%;
        box-sizing: border-box;
        margin: 5px 0;
        img {
          vertical-align: middle;
          margin-right: 6px;
        }
        span {
          color: #42cafc;
          white-space: nowrap;
          span {
            color: #f8b119;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
